module.exports = __webpack_public_path__ + "static/media/Image02.208b8ae9.png";